// Where the wage-unlock token lives for the current browser tab. sessionStorage (not localStorage) on purpose:
// it clears itself when the tab closes, matching "unlocked for this visit only" rather than a permanent bypass.
const KEY = "wage_unlock_token";

export const getWageToken = () => sessionStorage.getItem(KEY) || "";
export const setWageToken = (token) => sessionStorage.setItem(KEY, token);
export const clearWageToken = () => sessionStorage.removeItem(KEY);
export const wageHeader = () => (getWageToken() ? { "X-Wage-Token": getWageToken() } : {});
